onInteractive(function() {
	// Project photos are cropped to fill their card and the header photos take half the container, so the browser needs
	// the rendered width of the photo to pick a sharp source instead of the small default from the srcset.
	const pictures = document.querySelectorAll('.blog-item-preview-image picture, .header .carousel-item picture');
	const updateSizes = function() {
		pictures.forEach(function(picture) {
			const image = picture.querySelector('img');
			if (!image || !image.getAttribute('width') || !image.getAttribute('height')) {
				return;
			}
			const box = picture.getBoundingClientRect();
			if (!box.width) {
				return;
			}
			const ratio = image.getAttribute('width') / image.getAttribute('height');
			const width = Math.ceil(Math.max(box.width, box.height * ratio));
			picture.querySelectorAll('source, img').forEach(function(element) {
				element.setAttribute('sizes', width + 'px');
			});
		});
	};
	updateSizes();
	window.addEventListener('resize', updateSizes);
	// Hidden carousel slides have no size yet; they get their width once they slide in.
	if (window.jQuery) {
		window.jQuery('.header .carousel').on('slide.bs.carousel', function() {
			setTimeout(updateSizes, 0);
		});
	}
});
